import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ee08cb32")

_pushScopeId("data-v-ee08cb32")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "breadcrumb-wrap mt-1 mb-2" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb mb-0" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-home to-upper" }, null, -1)
const _hoisted_10 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_11 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_12 = { class: "col-6 text-right" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fa fa-angle-left mr-1" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fa fa-angle-left mr-1" }, null, -1)
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "form-group pt-0" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-lg-6" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { for: "exampleInputEmail1" }
const _hoisted_22 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_23 = {
  key: 0,
  class: "fa fa-trash-alt"
}
const _hoisted_24 = { class: "col-lg-6" }
const _hoisted_25 = {
  key: 0,
  class: "form-group"
}
const _hoisted_26 = { for: "exampleInputEmail1" }
const _hoisted_27 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_31 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_33 = {
  key: 0,
  class: "form-group"
}
const _hoisted_34 = { for: "exampleInputEmail1" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  key: 2,
  style: {"overflow-x":"scroll"},
  class: "custom-table-responsive my-2 font-12 border with-line-item"
}
const _hoisted_38 = { class: "table table-bordered mb-0" }
const _hoisted_39 = { class: "table-primary nowrap-text" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = { class: "input-group" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_47 = { class: "form-check form-check-inline" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox1"
}, "Email", -1)
const _hoisted_49 = { class: "form-check form-check-inline" }
const _hoisted_50 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_51 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_53 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_54 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "inviteMemberChatHistory",
  tabindex: "-1",
  "aria-labelledby": "inviteMemberChatHistory",
  "aria-hidden": "true"
}
const _hoisted_55 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_56 = { class: "modal-content" }
const _hoisted_57 = { class: "modal-header" }
const _hoisted_58 = { class: "d-block" }
const _hoisted_59 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_61 = { class: "modal-body" }
const _hoisted_62 = { class: "form-group pt-0" }
const _hoisted_63 = { class: "modal-title" }
const _hoisted_64 = { class: "text-muted" }
const _hoisted_65 = { class: "form-group mt-3" }
const _hoisted_66 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_67 = {
  class: "custom-control-label",
  for: "customRadioInline1"
}
const _hoisted_68 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_69 = {
  class: "custom-control-label",
  for: "customRadioInline2"
}
const _hoisted_70 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_71 = {
  class: "custom-control-label",
  for: "customRadioInline3"
}
const _hoisted_72 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_73 = {
  class: "custom-control-label",
  for: "customRadioInline4"
}
const _hoisted_74 = {
  key: 0,
  class: "row"
}
const _hoisted_75 = { class: "col-md-3" }
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = { class: "modal-footer" }
const _hoisted_78 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_79 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "inviteMemberCustomValidity",
  tabindex: "-1",
  "aria-labelledby": "inviteMemberCustomValidity",
  "aria-hidden": "true"
}
const _hoisted_80 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_81 = { class: "modal-content" }
const _hoisted_82 = { class: "modal-header" }
const _hoisted_83 = { class: "d-block" }
const _hoisted_84 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_85 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_86 = { class: "modal-body" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "form-group" }
const _hoisted_90 = /*#__PURE__*/_createVNode("label", { for: "startDate" }, "Initial Date", -1)
const _hoisted_91 = { class: "col-md-6" }
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = /*#__PURE__*/_createVNode("label", { for: "startDate" }, "Final Date", -1)
const _hoisted_94 = { class: "modal-footer" }
const _hoisted_95 = {
  key: 3,
  class: "alert alert-warning text-center",
  role: "alert"
}
const _hoisted_96 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" There are some errors, Please check above. ")
const _hoisted_98 = {
  key: 1,
  class: "form-group"
}
const _hoisted_99 = { for: "exampleInputEmail1" }
const _hoisted_100 = { class: "col-lg-2" }
const _hoisted_101 = { class: "form-group" }
const _hoisted_102 = { for: "exampleFullName" }
const _hoisted_103 = { class: "col-lg-3" }
const _hoisted_104 = { class: "form-group" }
const _hoisted_105 = { for: "exampleEmailInput" }
const _hoisted_106 = { class: "col-lg-3" }
const _hoisted_107 = { class: "form-group" }
const _hoisted_108 = { for: "exampleMobileNumber" }
const _hoisted_109 = { class: "input-group" }
const _hoisted_110 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_111 = { class: "col-lg-2" }
const _hoisted_112 = { for: "notifyByFormGroup" }
const _hoisted_113 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_114 = { class: "form-check form-check-inline" }
const _hoisted_115 = {
  class: "form-check-label",
  for: "inlineCheckbox1"
}
const _hoisted_116 = { class: "form-check form-check-inline" }
const _hoisted_117 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_118 = { class: "col-lg-2" }
const _hoisted_119 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_120 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_121 = { class: "mb-0" }
const _hoisted_122 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_123 = { class: "modal-body" }
const _hoisted_124 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_AppPhoneNumberInput = _resolveComponent("AppPhoneNumberInput")
  const _component_CustomSelect = _resolveComponent("CustomSelect")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_ProjectImageUploadModal = _resolveComponent("ProjectImageUploadModal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, " Invite Member in Project : " + _toDisplayString(_ctx.state.data.projectDetail.project.name), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("nav", _hoisted_6, [
              _createVNode("ol", _hoisted_7, [
                _createVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, { to: { name: 'admin-dashboard' } }, {
                    default: _withId(() => [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('home')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("li", _hoisted_10, [
                  _createVNode("a", _hoisted_11, _toDisplayString(_ctx.state.data.projectDetail.project.name), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          (!_ctx.state.data.channelHistoryUuid)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'admin-project-details' },
                class: "btn default-btn"
              }, {
                default: _withId(() => [
                  _hoisted_13,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock("button", {
                key: 1,
                class: "btn default-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectBackToSelectedChannel && _ctx.redirectBackToSelectedChannel(...args)))
              }, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
              ]))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.errors.errorList.invitation,
          hasError: _ctx.state.ui.errors.hasError
        }, null, 8, ["errors", "hasError"]),
        (!_ctx.state.data.invitationVerify.showStatus)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('select_channel')), 1),
                    _createVNode(_component_multiselect, {
                      modelValue: _ctx.selectedChannels,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedChannels = $event)),
                      options: _ctx.state.data.allChannels,
                      "close-on-select": "true",
                      "clear-on-select": true,
                      placeholder: _ctx.$t('search_and_select'),
                      label: "name",
                      "track-by": "name",
                      onSelect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectToChange(_ctx.selectedChannels))),
                      disabled: _ctx.state.ui.modal.selectedFromChannel
                    }, null, 8, ["modelValue", "options", "placeholder", "disabled"]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedAllChannel, (channel, channelIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "email-tag",
                        key: channelIndex
                      }, [
                        (channel.name)
                          ? (_openBlock(), _createBlock("p", _hoisted_22, [
                              _createTextVNode(_toDisplayString(channel.name) + " ", 1),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedChannel(channel))
                              }, [
                                (!_ctx.state.ui.modal.selectedFromChannel)
                                  ? (_openBlock(), _createBlock("i", _hoisted_23))
                                  : _createCommentVNode("", true)
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_24, [
                  (!_ctx.state.data.inviteAsGuest &&
                !_ctx.state.data.inviteAsPublicUser && _ctx.state.data.activeMemberList && _ctx.state.data.activeMemberList.length > 1
              )
                    ? (_openBlock(), _createBlock("div", _hoisted_25, [
                        _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('invite_existing_member')), 1),
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.selectedUsers,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedUsers = $event)),
                          options: _ctx.state.data.activeMemberList,
                          "custom-label": _ctx.nameWithEmail,
                          "close-on-select": "true",
                          "clear-on-select": true,
                          placeholder: _ctx.$t('search_and_select'),
                          label: "email",
                          "track-by": "email",
                          onSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectToChangeUsers(_ctx.selectedUsers)))
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite.users, (user, userIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "email-tag",
                            key: userIndex
                          }, [
                            (user.email && !user.phone)
                              ? (_openBlock(), _createBlock("p", _hoisted_27, [
                                  _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                  }, [
                                    _hoisted_28
                                  ], 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            (user.phone && !user.email)
                              ? (_openBlock(), _createBlock("p", _hoisted_29, [
                                  _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.phone) + ") ", 1),
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                  }, [
                                    _hoisted_30
                                  ], 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            (user.phone && user.email)
                              ? (_openBlock(), _createBlock("p", _hoisted_31, [
                                  _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") - (" + _toDisplayString(user.phone) + ") ", 1),
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                  }, [
                                    _hoisted_32
                                  ], 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (!_ctx.state.data.inviteAsPublicUser)
                ? (_openBlock(), _createBlock("div", _hoisted_33, [
                    _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('invite_new_member')), 1),
                    (_ctx.state.inputError)
                      ? (_openBlock(), _createBlock("p", _hoisted_35, _toDisplayString(_ctx.$t('please_fill_field')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.state.duplicate)
                      ? (_openBlock(), _createBlock("p", _hoisted_36, _toDisplayString(_ctx.$t('email_already_used')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.state.data.invite.invites && _ctx.state.data.invite.invites.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_37, [
                          _createVNode("table", _hoisted_38, [
                            _createVNode("thead", _hoisted_39, [
                              _createVNode("tr", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
                                  return (_openBlock(), _createBlock("th", {
                                    key: index,
                                    style: { width: _ctx.columnWidths[index] + 'px' },
                                    class: "resizable-column"
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t(column.label)) + " ", 1),
                                    _createVNode("div", {
                                      class: "resizer",
                                      onMousedown: ($event: any) => (_ctx.startResize(index, $event)),
                                      onTouchstart: ($event: any) => (_ctx.startResize(index, $event))
                                    }, null, 40, ["onMousedown", "onTouchstart"])
                                  ], 4))
                                }), 128))
                              ])
                            ]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite.invites, (invite, inviteIndex) => {
                              return (_openBlock(), _createBlock("tbody", { key: inviteIndex }, [
                                _createVNode("tr", null, [
                                  _createVNode("td", {
                                    style: { width: _ctx.computedInviteColumnWidth(0) }
                                  }, [
                                    _createVNode("div", _hoisted_40, [
                                      _withDirectives(_createVNode("input", {
                                        type: "text",
                                        class: invite.fNameError ? 'form-control error-field' : 'form-control',
                                        "onUpdate:modelValue": ($event: any) => (invite.first_name = $event)
                                      }, null, 10, ["onUpdate:modelValue"]), [
                                        [_vModelText, invite.first_name]
                                      ])
                                    ])
                                  ], 4),
                                  _createVNode("td", {
                                    style: { width: _ctx.computedInviteColumnWidth(1) }
                                  }, [
                                    _createVNode("div", _hoisted_41, [
                                      _withDirectives(_createVNode("input", {
                                        type: "text",
                                        class: invite.lNameError ? 'form-control error-field' : 'form-control',
                                        "onUpdate:modelValue": ($event: any) => (invite.last_name = $event)
                                      }, null, 10, ["onUpdate:modelValue"]), [
                                        [_vModelText, invite.last_name]
                                      ])
                                    ])
                                  ], 4),
                                  _createVNode("td", {
                                    style: { width: _ctx.computedInviteColumnWidth(2) }
                                  }, [
                                    _createVNode("div", _hoisted_42, [
                                      _createVNode("div", _hoisted_43, [
                                        _createVNode(_component_AppPhoneNumberInput, {
                                          style: { width: _ctx.computedInviteColumnWidth(2) },
                                          modelValue: invite.phone,
                                          "onUpdate:modelValue": ($event: any) => (invite.phone = $event),
                                          onInput: ($event: any) => (_ctx.checkEmptyFields(inviteIndex, 'phone'))
                                        }, null, 8, ["style", "modelValue", "onUpdate:modelValue", "onInput"])
                                      ])
                                    ])
                                  ], 4),
                                  _createVNode("td", {
                                    style: { width: _ctx.computedInviteColumnWidth(3) }
                                  }, [
                                    _createVNode("div", _hoisted_44, [
                                      _withDirectives(_createVNode("input", {
                                        type: "email",
                                        class: "form-control",
                                        "onUpdate:modelValue": ($event: any) => (invite.email = $event),
                                        onInput: ($event: any) => (_ctx.checkEmptyFields(inviteIndex, 'email'))
                                      }, null, 40, ["onUpdate:modelValue", "onInput"]), [
                                        [_vModelText, invite.email]
                                      ])
                                    ])
                                  ], 4),
                                  _createVNode("td", {
                                    style: { width: _ctx.computedInviteColumnWidth(4) }
                                  }, [
                                    _createVNode("div", _hoisted_45, [
                                      _createVNode("div", _hoisted_46, [
                                        _createVNode("div", _hoisted_47, [
                                          _withDirectives(_createVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "inlineCheckbox1",
                                            value: "true",
                                            "onUpdate:modelValue": ($event: any) => (invite.mailNotification = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelCheckbox, invite.mailNotification]
                                          ]),
                                          _hoisted_48
                                        ]),
                                        _createVNode("div", _hoisted_49, [
                                          _withDirectives(_createVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "inlineCheckbox2",
                                            value: "true",
                                            "onUpdate:modelValue": ($event: any) => (invite.smsNotification = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelCheckbox, invite.smsNotification]
                                          ]),
                                          _createVNode("label", _hoisted_50, _toDisplayString(_ctx.$t('sms')), 1)
                                        ])
                                      ])
                                    ])
                                  ], 4),
                                  _createVNode("td", {
                                    style: { width: _ctx.computedInviteColumnWidth(5) }
                                  }, [
                                    _createVNode(_component_CustomSelect, {
                                      modelValue: invite.validity,
                                      "onUpdate:modelValue": ($event: any) => (invite.validity = $event),
                                      options: [
                        { value: '7', label: '1 Week' },
                        { value: '30', label: '1 Month' },
                        { value: '90', label: '3 Months' },
                        { value: '180', label: '6 Months' },
                        { value: '365', label: '1 Year' },
                        { value: '0', label: 'Never Expires' },
                        {
                          value: 'custom',
                          label: invite.start_date && invite.end_date
                            ? `${invite.custom_start_date} - ${invite.custom_end_date}`
                            : 'Custom'
                        }
                      ],
                                      onOnChange: ({ value, index }) => _ctx.changeChannelStatus(value, inviteIndex),
                                      disabled: !_ctx.hasValidLastContact
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onOnChange", "disabled"])
                                  ], 4),
                                  _createVNode("td", {
                                    style: { width: _ctx.computedInviteColumnWidth(6) }
                                  }, [
                                    (invite.message_share === 1 || invite.message_share === '1')
                                      ? (_openBlock(), _createBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn btn-sm text-primary",
                                          disabled: (!invite.first_name && !invite.last_name && !invite.phone) || (!invite.first_name && !invite.last_name && !invite.email),
                                          onClick: ($event: any) => (_ctx.showChatHistory(inviteIndex, invite.message_share))
                                        }, "Invitation Accepted", 8, ["disabled", "onClick"]))
                                      : _createCommentVNode("", true),
                                    (invite.message_share === 2 || invite.message_share === '2')
                                      ? (_openBlock(), _createBlock("button", {
                                          key: 1,
                                          type: "button",
                                          class: "btn btn-sm text-primary",
                                          disabled: (!invite.first_name && !invite.last_name && !invite.phone) || (!invite.first_name && !invite.last_name && !invite.email),
                                          onClick: ($event: any) => (_ctx.showChatHistory(inviteIndex, invite.message_share))
                                        }, "Today", 8, ["disabled", "onClick"]))
                                      : _createCommentVNode("", true),
                                    (invite.message_share === 3 || invite.message_share === '3')
                                      ? (_openBlock(), _createBlock("button", {
                                          key: 2,
                                          type: "button",
                                          class: "btn btn-sm text-primary",
                                          disabled: (!invite.first_name && !invite.last_name && !invite.phone) || (!invite.first_name && !invite.last_name && !invite.email),
                                          onClick: ($event: any) => (_ctx.showChatHistory(inviteIndex, invite.message_share))
                                        }, "From Beginning", 8, ["disabled", "onClick"]))
                                      : _createCommentVNode("", true),
                                    ((invite.message_share === 4 || invite.message_share === '4') && invite.messageShareDetails)
                                      ? (_openBlock(), _createBlock("button", {
                                          key: 3,
                                          type: "button",
                                          class: "btn btn-sm text-primary",
                                          disabled: (!invite.first_name && !invite.last_name && !invite.phone) || (!invite.first_name && !invite.last_name && !invite.email),
                                          onClick: ($event: any) => (_ctx.showChatHistory(inviteIndex, invite.message_share))
                                        }, _toDisplayString(invite.messageShareDetails), 9, ["disabled", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ], 4),
                                  _createVNode("td", {
                                    class: "text-nowrap",
                                    style: { width: _ctx.computedInviteColumnWidth(7) }
                                  }, [
                                    (_ctx.state.data.invite.invites.length === inviteIndex + 1)
                                      ? (_openBlock(), _createBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn btn-sm text-primary mr-1",
                                          disabled: !_ctx.hasValidLastContact,
                                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addNewMember && _ctx.addNewMember(...args)))
                                        }, [
                                          _hoisted_51,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                                        ], 8, ["disabled"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.state.data.invite.invites.length != 1)
                                      ? (_openBlock(), _createBlock("a", {
                                          key: 1,
                                          title: "Delete",
                                          href: "javascript:void(0)",
                                          class: "btn btn-sm text-danger",
                                          disabled: _ctx.state.data.invite.invites.length === 1,
                                          onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                        }, [
                                          _hoisted_52,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                        ], 8, ["disabled", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ], 4)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_53, [
                      _createVNode("div", _hoisted_54, [
                        _createVNode("div", _hoisted_55, [
                          _createVNode("div", _hoisted_56, [
                            _createVNode("div", _hoisted_57, [
                              _createVNode("div", _hoisted_58, [
                                _createVNode("h5", _hoisted_59, _toDisplayString(_ctx.state.data.selectedMember.first_name) + " " + _toDisplayString(_ctx.state.data.selectedMember.last_name) + "(" + _toDisplayString(_ctx.state.data.selectedMember.email) + ") ", 1)
                              ]),
                              _createVNode("button", {
                                type: "button",
                                class: "close",
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hideChatHistory && _ctx.hideChatHistory(...args))),
                                "aria-label": "Close"
                              }, [
                                _hoisted_60
                              ])
                            ]),
                            _createVNode("div", _hoisted_61, [
                              _createVNode("div", _hoisted_62, [
                                _createVNode("h5", _hoisted_63, _toDisplayString(_ctx.$t('include_conversation_history')), 1),
                                _createVNode("p", _hoisted_64, _toDisplayString(_ctx.$t('conversation_history_description')), 1),
                                _createVNode("div", _hoisted_65, [
                                  _createVNode("div", _hoisted_66, [
                                    _withDirectives(_createVNode("input", {
                                      type: "radio",
                                      id: "customRadioInline1",
                                      name: "customRadioInline",
                                      value: "1",
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedValue = $event)),
                                      class: "custom-control-input"
                                    }, null, 512), [
                                      [_vModelRadio, _ctx.selectedValue]
                                    ]),
                                    _createVNode("label", _hoisted_67, _toDisplayString(_ctx.$t('from_invitation_accepted')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_68, [
                                    _withDirectives(_createVNode("input", {
                                      type: "radio",
                                      id: "customRadioInline2",
                                      name: "customRadioInline",
                                      value: "2",
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedValue = $event)),
                                      class: "custom-control-input"
                                    }, null, 512), [
                                      [_vModelRadio, _ctx.selectedValue]
                                    ]),
                                    _createVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('from_today')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_70, [
                                    _withDirectives(_createVNode("input", {
                                      type: "radio",
                                      id: "customRadioInline3",
                                      name: "customRadioInline",
                                      value: "3",
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedValue = $event)),
                                      class: "custom-control-input"
                                    }, null, 512), [
                                      [_vModelRadio, _ctx.selectedValue]
                                    ]),
                                    _createVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('from_the_beginning')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_72, [
                                    _withDirectives(_createVNode("input", {
                                      type: "radio",
                                      id: "customRadioInline4",
                                      name: "customRadioInline",
                                      value: "4",
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedValue = $event)),
                                      class: "custom-control-input"
                                    }, null, 512), [
                                      [_vModelRadio, _ctx.selectedValue]
                                    ]),
                                    _createVNode("label", _hoisted_73, _toDisplayString(_ctx.$t('custom')), 1)
                                  ])
                                ]),
                                (_ctx.selectedValue === '4')
                                  ? (_openBlock(), _createBlock("div", _hoisted_74, [
                                      _createVNode("div", _hoisted_75, [
                                        _createVNode("div", _hoisted_76, [
                                          _createVNode(_component_v_date_picker, {
                                            modelValue: _ctx.selectedDateForMember,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedDateForMember = $event))
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createVNode("div", _hoisted_77, [
                              _createVNode("div", null, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "btn default-btn mr-2",
                                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveDateToselectedMember && _ctx.saveDateToselectedMember(...args)))
                                }, _toDisplayString(_ctx.$t('save')), 1),
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "btn secondary-btn mr-2",
                                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideChatHistory && _ctx.hideChatHistory(...args)))
                                }, _toDisplayString(_ctx.$t('cancel')), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_78, [
                      _createVNode("div", _hoisted_79, [
                        _createVNode("div", _hoisted_80, [
                          _createVNode("div", _hoisted_81, [
                            _createVNode("div", _hoisted_82, [
                              _createVNode("div", _hoisted_83, [
                                _createVNode("h5", _hoisted_84, _toDisplayString(_ctx.state.data.selectedMember.first_name) + " " + _toDisplayString(_ctx.state.data.selectedMember.last_name) + "(" + _toDisplayString(_ctx.state.data.selectedMember.email || _ctx.state.data.selectedMember.phone) + ") ", 1)
                              ]),
                              _createVNode("button", {
                                type: "button",
                                class: "close",
                                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.hideCustomValidity && _ctx.hideCustomValidity(...args))),
                                "aria-label": "Close"
                              }, [
                                _hoisted_85
                              ])
                            ]),
                            _createVNode("div", _hoisted_86, [
                              _createVNode("div", _hoisted_87, [
                                _createVNode("div", _hoisted_88, [
                                  _createVNode("div", _hoisted_89, [
                                    _hoisted_90,
                                    _createVNode(_component_v_date_picker, {
                                      id: "startDate",
                                      modelValue: _ctx.customStartDate,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.customStartDate = $event))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_91, [
                                  _createVNode("div", _hoisted_92, [
                                    _hoisted_93,
                                    _createVNode(_component_v_date_picker, {
                                      id: "endDate",
                                      modelValue: _ctx.customEndDate,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.customEndDate = $event))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_94, [
                              _createVNode("div", null, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "btn default-btn mr-2",
                                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.saveCustomDaysToselectedMember && _ctx.saveCustomDaysToselectedMember(...args)))
                                }, _toDisplayString(_ctx.$t('save')), 1),
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "btn secondary-btn mr-2",
                                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.hideCustomValidity && _ctx.hideCustomValidity(...args)))
                                }, _toDisplayString(_ctx.$t('cancel')), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.state.errorList && _ctx.state.errorList.length && _ctx.state.isErrorStatus)
                      ? (_openBlock(), _createBlock("div", _hoisted_95, [
                          _hoisted_96,
                          _hoisted_97
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_98, [
                    _createVNode("label", _hoisted_99, _toDisplayString(_ctx.$t('invite_new_member_email_number')), 1),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.inviteAsPublic, (publicMember, indexPublicMember) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "row mb-3 align-items-center",
                        key: indexPublicMember
                      }, [
                        _createVNode("div", _hoisted_100, [
                          _createVNode("div", _hoisted_101, [
                            _createVNode("label", _hoisted_102, _toDisplayString(_ctx.$t('full_name')), 1),
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "exampleFullName",
                              placeholder: _ctx.$t('your_full_name'),
                              "onUpdate:modelValue": ($event: any) => (publicMember.name = $event)
                            }, null, 8, ["placeholder", "onUpdate:modelValue"]), [
                              [_vModelText, publicMember.name]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_103, [
                          _createVNode("div", _hoisted_104, [
                            _createVNode("label", _hoisted_105, _toDisplayString(_ctx.$t('email')), 1),
                            _withDirectives(_createVNode("input", {
                              type: "email",
                              class: "form-control",
                              id: "exampleEmailInput",
                              placeholder: "abc@convorally.com",
                              "onUpdate:modelValue": ($event: any) => (publicMember.email = $event)
                            }, null, 8, ["onUpdate:modelValue"]), [
                              [_vModelText, publicMember.email]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_106, [
                          _createVNode("div", _hoisted_107, [
                            _createVNode("label", _hoisted_108, _toDisplayString(_ctx.$t('mobile_number')), 1),
                            _createVNode("div", _hoisted_109, [
                              _hoisted_110,
                              _withDirectives(_createVNode("input", {
                                type: "number",
                                class: "form-control",
                                id: "exampleMobileNumber",
                                placeholder: _ctx.$t('mobile_number_only'),
                                "onUpdate:modelValue": ($event: any) => (publicMember.phone = $event)
                              }, null, 8, ["placeholder", "onUpdate:modelValue"]), [
                                [_vModelText, publicMember.phone]
                              ])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_111, [
                          _createVNode("label", _hoisted_112, _toDisplayString(_ctx.$t('notify_by')), 1),
                          _createVNode("div", _hoisted_113, [
                            _createVNode("div", _hoisted_114, [
                              _withDirectives(_createVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "inlineCheckbox1",
                                value: "false",
                                "onUpdate:modelValue": ($event: any) => (publicMember.mailNotification = $event)
                              }, null, 8, ["onUpdate:modelValue"]), [
                                [_vModelCheckbox, publicMember.mailNotification]
                              ]),
                              _createVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('email')), 1)
                            ]),
                            _createVNode("div", _hoisted_116, [
                              _withDirectives(_createVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "inlineCheckbox2",
                                value: "false",
                                "onUpdate:modelValue": ($event: any) => (publicMember.smsNotification = $event)
                              }, null, 8, ["onUpdate:modelValue"]), [
                                [_vModelCheckbox, publicMember.smsNotification]
                              ]),
                              _createVNode("label", _hoisted_117, _toDisplayString(_ctx.$t('sms')), 1)
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_118, [
                          (indexPublicMember + 1 ==
                  _ctx.state.inviteAsPublic.length ||
                  _ctx.state.inviteAsPublic.length === 1
                )
                            ? (_openBlock(), _createBlock("button", {
                                key: 0,
                                class: "btn default-btn mr-1",
                                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.changeInvitePublicMember && _ctx.changeInvitePublicMember(...args)))
                              }, [
                                _hoisted_119,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.inviteAsPublic &&
                  _ctx.state.inviteAsPublic.length > 1
                )
                            ? (_openBlock(), _createBlock("a", {
                                key: 1,
                                class: "btn btn-danger",
                                onClick: ($event: any) => (_ctx.deletePublicMember(publicMember)),
                                href: "javascript:void(0)"
                              }, [
                                _hoisted_120,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite.invites, (invite, inviteIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        key: inviteIndex,
                        class: "email-tag"
                      }, [
                        _createVNode("p", _hoisted_121, [
                          _createTextVNode(_toDisplayString(invite) + " ", 1),
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                          }, [
                            _hoisted_122,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                          ], 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", null, [
        _createVNode("a", {
          href: "javascript:void(0)",
          class: "btn secondary-btn mr-2",
          onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.hideAddMember && _ctx.hideAddMember(...args)))
        }, _toDisplayString(_ctx.$t('cancel')), 1),
        (_ctx.state.data.inviteAsPublicUser)
          ? (_openBlock(), _createBlock("a", {
              key: 0,
              href: "javascript:void(0)",
              class: "btn default-btn",
              onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.inviteAllPublicUser && _ctx.inviteAllPublicUser(...args)))
            }, _toDisplayString(_ctx.$t('send')), 1))
          : (_openBlock(), _createBlock("a", {
              key: 1,
              href: "javascript:void(0)",
              class: "btn default-btn",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.inviteAllUsers && _ctx.inviteAllUsers(...args)))
            }, _toDisplayString(_ctx.state.ui.isPostLoading.inviteAllUsers ? _ctx.$t('sending') : _ctx.$t('send')), 1))
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage,
          subTitleMessage: _ctx.state.data.subTitleMessage,
          isButton: _ctx.state.data.isChannelCreated
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_123, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mb-2",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.continueInvite && _ctx.continueInvite(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('continue_to_invite_members')) + " ", 1),
                _hoisted_124
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage", "subTitleMessage", "isButton"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showProjectImageUploadModal)
      ? (_openBlock(), _createBlock(_component_ProjectImageUploadModal, {
          key: 1,
          onClose: _ctx.closeProjectImageUploadModal,
          showModal: _ctx.state.data.showProjectImageUploadModal,
          project: _ctx.state.data.projectDetail.project
        }, null, 8, ["onClose", "showModal", "project"]))
      : _createCommentVNode("", true)
  ]))
})